import ShaderBase from "./_shaderBase.js";
import { fieldUniforms } from "./shader-chunks.js";
export default class Aurora extends ShaderBase {}
Aurora.prototype.defaultOptions = {
  color: 0x38efb0,
  color2: 0x8360ff,
  backgroundColor: 0x060e20,
};
Aurora.prototype.fragmentShader =
  fieldUniforms +
  `
void main(){vec2 uv=gl_FragCoord.xy/iResolution;vec2 p=vec2(uv.x*iResolution.x/iResolution.y,uv.y);p.x+=(iMouse.x/iResolution.x-.5)*.2;
vec3 col=backgroundColor;for(int i=0;i<5;i++){float fi=float(i);float ridge=.36+.11*fi+.12*sin(p.x*2.+iTime*.18+fi)+.07*noise(vec2(p.x*4.+fi,iTime*.08));float curtain=exp(-abs(p.y-ridge)*13.)*(.4+.6*noise(vec2(p.x*19.,fi+iTime*.1)));col+=mix(color,color2,fi/4.)*curtain*.36*intensity;}
gl_FragColor=vec4(col,1.);}`;
